import { COLLECTIONS } from '../../constants/collections';
import { createDocument, getDocument, getAllDocuments, updateDocument, deleteDocument } from './firestoreService';

/**
 * Door Group Service - Rampa Grubu yönetimi
 */

const getCollectionPath = (tenantId) => `tenants/${tenantId}/${COLLECTIONS.DOOR_GROUPS}`;

// Create door group
export const createDoorGroup = async (doorGroupData, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    const data = {
        ...doorGroupData,
        tenantId,
        isActive: true,
        createdAt: new Date(),
        updatedAt: new Date()
    };
    return await createDocument(getCollectionPath(tenantId), data);
};

// Get door group by ID
export const getDoorGroup = async (doorGroupId, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    return await getDocument(getCollectionPath(tenantId), doorGroupId);
};

// Get all door groups for a tenant
export const getAllDoorGroups = async (tenantId, activeOnly = false) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    const conditions = [];

    // No need to filter by tenantId as we are in the subcollection

    let results = await getAllDocuments(getCollectionPath(tenantId), conditions);

    if (activeOnly) {
        results = results.filter(item => item.isActive === true);
    }

    return results;
};

// Get door groups by factory ID
export const getDoorGroupsByFactory = async (tenantId, factoryId, activeOnly = false) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    const conditions = [
        { type: 'where', field: 'factoryId', operator: '==', value: factoryId }
    ];

    let results = await getAllDocuments(getCollectionPath(tenantId), conditions);

    if (activeOnly) {
        results = results.filter(item => item.isActive === true);
    }

    // Sort client-side to avoid composite index requirement
    return results.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
};

// Update door group
export const updateDoorGroup = async (doorGroupId, updates, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    const data = {
        ...updates,
        updatedAt: new Date()
    };
    return await updateDocument(getCollectionPath(tenantId), doorGroupId, data);
};

// Delete door group
export const deleteDoorGroup = async (doorGroupId, tenantId) => {
    if (!tenantId) throw new Error('Tenant ID is required');
    return await deleteDocument(getCollectionPath(tenantId), doorGroupId);
};

// Deactivate door group
export const deactivateDoorGroup = async (doorGroupId, tenantId) => {
    return await updateDoorGroup(doorGroupId, { isActive: false }, tenantId);
};

// Activate door group
export const activateDoorGroup = async (doorGroupId, tenantId) => {
    return await updateDoorGroup(doorGroupId, { isActive: true }, tenantId);
};
